exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-fbf39f80]{position:relative}.wrapper .desc-wrapper[data-v-fbf39f80]{display:none}.wrapper:hover .desc-wrapper[data-v-fbf39f80]{display:block}.desc-wrapper[data-v-fbf39f80]{position:absolute;top:25px;left:0;width:250px;z-index:10}", ""]);

// exports
